import { CtaIcon } from 'components/Common/Icon'
import Link from 'next/link'
import styles from './AiInRecruitingCtaSection.module.css'

const AiInRecruitingCtaSection = () => {
  return (
    <section className={styles.ctaSection}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12">
            <div className={styles.content}>
              <h2 className={styles.title}>
                Get AI Recruiting Working for Your Business Today
              </h2>
              <p className={styles.subtitle}>
                Build a faster, smarter, and more predictable hiring system with
                AI-driven recruitment solutions.
              </p>
              <Link
                className="cta-button cta-button-black cta-button-main"
                href="/get-quote/"
              >
                <span>Schedule Your Free Consultation</span>
                <span className="arrow">
                  <CtaIcon className="fill-white" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingCtaSection
